import { Button, InputNumber } from "antd";
import { ReactNode, useCallback } from "react";
import styled from "styled-components";

import { poppins } from "@/components/common/fonts";

export const QuantityInput = ({
  value = 1,
  unit,
  onChange,
  min = 0,
  max = Infinity,
  disabled = false,
}: {
  value?: number;
  unit?: ReactNode;
  onChange?: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}) => {
  const handleDown = useCallback(() => {
    if (value <= min) {
      return;
    }

    onChange?.(value - 1);
  }, [onChange, value, min]);
  const handleUp = useCallback(() => {
    if (value >= max) {
      return;
    }

    onChange?.(value + 1);
  }, [onChange, value, max]);

  return (
    <StyledInputNumber
      addonBefore={
        <QuantityInputButton
          onClick={handleDown}
          disabled={value <= min || disabled}
          type="text"
        >
          -
        </QuantityInputButton>
      }
      addonAfter={
        <QuantityInputButton
          onClick={handleUp}
          disabled={value >= max || disabled}
          type="text"
        >
          +
        </QuantityInputButton>
      }
      controls={false}
      suffix={unit}
      value={value}
      onChange={(changedValue) => onChange?.(changedValue ?? min)}
      min={min}
      max={max}
      precision={0}
      disabled={disabled}
    />
  );
};

const StyledInputNumber = styled(InputNumber<number>)`
  width: 150px;
  height: 36px;

  .ant-input-number-group-addon {
    display: flex-inline;
    align-items: center;
    justify-content: center;

    padding: 0;

    overflow: hidden;
  }

  .ant-input-number-affix-wrapper {
    padding: 0;
  }

  && input {
    height: 36px;
    text-align: right;

    color: #282b31;
    ${poppins.style}
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 171.429% */
    letter-spacing: -0.28px;
  }

  .ant-input-number-suffix {
    color: #282b31;
    text-align: center;
    ${poppins.style}
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.24px;
  }
`;

const QuantityInputButton = styled(Button)`
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 0;

  color: #282b31;
  text-align: center;
  ${poppins.style}
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
